import React, { useState } from 'react';
import { RawMaterial } from '../models/raw-material';
import { RawMaterialSearchRequest } from '../models/raw-material-search-request';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import DataGrid, {
    Column,
    Selection,
    Paging,
    HeaderFilter,
    FilterRow,
    LoadPanel
} from 'devextreme-react/data-grid';

import { TextBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';

import { ResponseError } from '../models/response-error';
import { CrudFunctions } from '../utilities/crud-functions';

export interface Props {
    onApplySelection?: (rawMaterial: RawMaterial) => void;
    onCancel?: () => void;
}

export default function RawMaterialSearch(props: Props) {
    const [rawMaterialNameFilter, setRawMaterialNameFilter] =
        useState<string>();

    const [rawMaterialDescriptionFilter, setRawMaterialDescriptionFilter] =
        useState<string>();

    const [rawMaterials, setRawMaterials] =
        useState<RawMaterial[]>();

    const [selectedRawMaterial, setSelectedRawMaterial] =
        useState<RawMaterial>();

    const [rawMaterialSearchRequest, setRawMaterialSearchRequest] =
        useState<RawMaterialSearchRequest>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();
        
    return (
        <div>
            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">Name</label>
                    <TextBox id="rawMaterialNameFilter" className="textbox"
                        onValueChanged={rawMaterialNameFilterValueChanged}
                        showClearButton={true}
                        placeholder="name" value={rawMaterialNameFilter ? rawMaterialNameFilter : undefined} />
                </div>

                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">Description</label>
                    <TextBox id="rawMaterialDescriptionFilter" className="textbox"
                        showClearButton={true}
                        onValueChanged={rawMaterialDescriptionFilterValueChanged}
                        placeholder="description" value={rawMaterialDescriptionFilter ? rawMaterialDescriptionFilter : undefined} />
                </div>
                <div className="pw-row-button-13 ">
                    <Button id="searchButton" text="Search" icon="find" type="success"
                        hint="search"
                        height={'2.6em'}
                        onClick={onSearch} />
                </div>
            </div>

            <div className="pw-comp-row">
                <DataGrid
                    height="28rem"
                    dataSource={rawMaterials ? rawMaterials : []}
                    onSelectionChanged={rawMaterialSelectionChanged}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Selection mode={'single'} />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <Paging enabled={false} />

                    <Column dataField={'name'} width='40%' />
                    <Column dataField={'description'} width='60%' />

                </DataGrid>
            </div>

            <div className="pw-comp-row pw-margin-top-1">
                <div className="pw-centered-buttons-container">
                    <Button id="applySelectionButton"
                        className="pw-button"
                        text="Apply" type="success"
                        hint="apply selection"
                        height={'2.6em'}
                        onClick={onApplyClick} />

                    <Button id="cancelButton"
                        className="pw-button"
                        text="Cancel" type="normal"
                        hint="cancel"
                        height={'2.6em'}
                        onClick={onCancelClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );


    function rawMaterialNameFilterValueChanged(e: any) {
        setRawMaterialNameFilter(e.value);
    }

    function rawMaterialDescriptionFilterValueChanged(e: any) {
        setRawMaterialDescriptionFilter(e.value);
    }

    function onApplyClick(e: any) {
        if (selectedRawMaterial && props.onApplySelection)
            props.onApplySelection(selectedRawMaterial);
    }

    function onCancelClick(e: any) {
        if (props.onCancel)
            props.onCancel();
    }

    function rawMaterialSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedRawMaterial(e.selectedRowsData[0]);
        }
    }

    function onSearch(e: any) {
        let request: RawMaterialSearchRequest = {
            name: rawMaterialNameFilter,
            description: rawMaterialDescriptionFilter
        }

        CrudFunctions.postData("common/rawmaterialsearch", request)
            .then((data) => {
                setRawMaterials(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Raw Materials");
            });
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}

